const RecursiveFrxToJson = function (xml_item, counter) {
  const result = {
    _tipo: xml_item.tagName,
    _children: new Array(),
    _id: ++counter.counter,
  };
  let length = xml_item.attributes.length;
  for (let i = 0; i < length; i++) {
    result[xml_item.attributes[i].name] = xml_item.attributes[i].value;
  }

  length = xml_item.children.length;
  for (let i = 0; i < length; i++) {
    result._children.push(RecursiveFrxToJson(xml_item.children[i], counter));
  }
  return result;
};

export function FrxToJson(model) {
  let model_str;
  try {
    model_str = decodeURIComponent(decodeURIComponent(escape(atob(model))));
  } catch {
    model_str = decodeURIComponent(escape(atob(model)));
  }
  const xml = new DOMParser().parseFromString(model_str, "text/xml");
  const root = xml.getElementsByTagName("ReportPage")[0];
  const result = RecursiveFrxToJson(root, { counter: 0 });
  return result;
}

const RecursiveJsonToFrx = function (xml, json_item) {
  const result = xml.createElement(json_item._tipo);
  const attributes = Object.keys(json_item);
  let length = attributes.length;
  for (let i = 0; i < length; i++) {
    const attribute = attributes[i];
    if (
      attribute == "_tipo" ||
      attribute == "_children" ||
      attribute == "_id"
    ) {
      continue;
    }
    result.setAttribute(attribute, json_item[attribute]);
  }

  length = json_item._children.length;
  for (let i = 0; i < length; i++) {
    result.appendChild(RecursiveJsonToFrx(xml, json_item._children[i]));
  }

  return result;
};

export function JsonToFrx(json, original_model) {
  let model_str; 
  try {
    model_str = decodeURIComponent(
      decodeURIComponent(escape(atob(original_model))))
  } catch {
    model_str = decodeURIComponent(escape(atob(original_model)))
  }
  const xml = new DOMParser().parseFromString(model_str, "text/xml");
  const root = xml.getElementsByTagName("ReportPage")[0];
  const root_container = root.parentElement;
  root_container.removeChild(root);
  const new_root = RecursiveJsonToFrx(xml, json);
  root_container.appendChild(new_root);

  const xml_str = new XMLSerializer().serializeToString(xml);
  return btoa(unescape(encodeURIComponent(xml_str)));
}
